export default function workMotivesDataFormatter(data) {
  return [
    ...data.calculation_container.occupational_profile_calculation_containers
  ];
}
